



































































































































import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class LookupListPage extends Vue {
  lookup = this.$store.state.lookup;
  application = this.$store.state.application;
  selectedItem = 0;
  editedIndex = -1;
  actualPage = 1;
  editedItem = { value: '', additionalParameters: {} };
  dialog = false;
  changedName = false;
  changedDescription = false;
  valid = true;
  public requiredRule = [(v: string) => !!v || this.$t('error.requiredField')];
  emailRules = [(v: string) => !!v || this.$t('error.requiredField'), (v: string) => /.+@.+\..+/.test(v) || this.$t('error.emailFormat')];
  search = '';

  created(): void {
    if (this.lookup.detail) {
      this.selectedItem = this.lookup.detail.id;
    }

    this.$store.dispatch('lookup/getAll');
  }

  get hasReferenceKey() {
    return this.selectedItem === 4 || this.selectedItem === 9;
  }

  get isSolverLookup() {
    return this.selectedItem === 14;
  }

  get lookupItems(): [] {
    return this.$store.getters['lookup/getLookupItems']();
  }

  get headers() {
    if (this.hasReferenceKey) {
      return [
        { text: this.$t('lookups.value'), value: 'value', width: '20%' },
        { text: this.$t('lookups.value2'), value: 'value2', width: '20%' },
        { text: this.$t('lookups.parentId'), value: 'parentId', sortable: false, width: '5%', align: 'center' },
        { text: this.$t('lookups.key'), value: 'key', width: '20%', sortable: false, align: 'center' },
        { text: this.$t('lookups.referenceKey'), value: 'referenceKey', width: '10%', sortable: false, align: 'center' },
        { text: this.$t('general.edit'), value: 'edit', sortable: false, align: 'center' },
        { text: this.$t('general.delete'), value: 'delete', sortable: false, align: 'center' }
      ];
    }

    if (this.isSolverLookup) {
      return [
        { text: this.$t('lookups.value'), value: 'value', width: '15%' },
        { text: this.$t('lookups.value2'), value: 'value2', width: '15%' },
        { text: this.$t('lookups.email'), value: 'additionalParameters.Email', width: '15%' },
        { text: this.$t('lookups.personalNumber'), value: 'additionalParameters.PersonalNumber', width: '10%' },
        { text: this.$t('lookups.parentId'), value: 'parentId', sortable: false, width: '10%', align: 'center' },
        { text: this.$t('lookups.key'), value: 'key', width: '20%', sortable: false, align: 'center' },
        { text: this.$t('general.edit'), value: 'edit', sortable: false, align: 'center' },
        { text: this.$t('general.delete'), value: 'delete', sortable: false, align: 'center' }
      ];
    }

    return [
      { text: this.$t('lookups.value'), value: 'value', width: '30%' },
      { text: this.$t('lookups.value2'), value: 'value2', width: '30%' },
      { text: this.$t('lookups.parentId'), value: 'parentId', sortable: false, width: '10%', align: 'center' },
      { text: this.$t('lookups.key'), value: 'key', width: '10%', sortable: false, align: 'center' },
      { text: this.$t('general.edit'), value: 'edit', sortable: false, align: 'center' },
      { text: this.$t('general.delete'), value: 'delete', sortable: false, align: 'center' }
    ];
  }

  get keyValidation() {
    return [
      (value: string) => !!value || this.$t('error.requiredField'),
      (value: string) => this.lookupItems.find((item: any) => item.key === value) === undefined || this.editedIndex > -1 || this.$t('error.keyExists')
    ];
  }

  get lookups() {
    return this.lookup.items.sort((a: any, b: any) => (a.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') < b.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '') ? -1 : 1));
  }

  nameChanged(value: any): void {
    if (value !== '') {
      this.changedName = true;
    }
  }

  descriptionChanged(value: any): void {
    if (value !== '') {
      this.changedDescription = true;
    }
  }

  getLookupDetail() {
    if (this.hasReferenceKey) {
      this.loadItems();
    }

    this.actualPage = 1;
    this.$store.dispatch('lookup/getById', this.selectedItem);
    this.changedName = false;
    this.changedDescription = false;
  }

  saveLookup() {
    const lookup = this.lookup.detail;
    const id = this.lookup.detail.id;
    this.$store.dispatch('lookup/updateLookup', { id, lookup });
    this.$store.commit('lookup/clearLookup', { id });
    this.changedName = false;
    this.changedDescription = false;
  }

  editItem(item: any) {
    this.editedIndex = this.lookup.detail.items.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.editedItem.additionalParameters = Object.assign({}, item.additionalParameters);
    this.dialog = true;
  }

  deleteItem(item: any) {
    const lookupId = this.selectedItem;
    const lookupItem = item;
    lookupItem.IsDisabled = true;
    const id = item.id;
    this.$store.dispatch('lookup/updateLookupItem', { lookupId, id, lookupItem });
    this.$store.commit('lookup/clearLookup', lookupId);
  }

  close() {
    this.dialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, { value: '', additionalParameters: {} });
      this.editedIndex = -1;
      (this.$refs.form as any).reset();
    });
  }

  save() {
    (this.$refs.form as any).validate();
    if (this.valid) {
      if (this.editedIndex > -1) {
        const lookupId = this.selectedItem;
        const lookupItem = this.editedItem;
        const id = (this.editedItem as any).id;
        this.$store.dispatch('lookup/updateLookupItem', { lookupId, id, lookupItem });
        this.$store.commit('lookup/clearLookup', lookupId);
      } else {
        const id = this.selectedItem;
        const lookupItem = this.editedItem;
        (lookupItem as any).parentId = this.selectedItem;

        this.$store.dispatch('lookup/createLookupItem', { id, lookupItem });
        this.$store.commit('lookup/clearLookup', id);
      }
      this.close();
    }
  }

  onPage(page: number): void {
    this.actualPage = page;
  }

  async loadItems() {
    const id = this.selectedItem === 9 ? 8 : 2;
    this.$store.dispatch('lookup/getAvailableLookup', id);
  }

  getLookup() {
    if (this.hasReferenceKey) {
      const id = this.selectedItem === 9 ? 8 : 2;

      return this.$store.getters['lookup/getAvailableLookupDetail'](id);
    }
  }
}
